(
    function (skyward, $, undefined)
    {
        skyward.successed = skyward.successed || {};
        
        var init = function (selector)
        {
            "use strict";

            var pageCheck = $(selector).find("#EC307842-96B3-49AC-A1A8-3338540F5D86");

            if (pageCheck.length > 0)
            {
                var handleImportTypeCodeChange = function ()
                {
                    var specialEdRadioButton = $("#ImportTypeCode_1");
                    var fileSelect = $("#fileSelect");
                    var chooseFileRadioButton;

                    if (specialEdRadioButton.is(":checked"))
                    {
                        chooseFileRadioButton = $("#FilePathOptionSpecial_1");
                    }
                    else
                    {
                        chooseFileRadioButton = $("#FilePathOptionRestraint_1");
                    }

                    if (chooseFileRadioButton.is(":checked"))
                    {
                        fileSelect.show();
                    }
                    else
                    {
                        fileSelect.hide();
                    }
                }

                var importTypeCode = $(selector).find("#ImportTypeCode");

                var importTypeCodeChange = function ()
                {
                    handleImportTypeCodeChange();
                }

                importTypeCode.on("change", importTypeCodeChange);
            }
        }
        
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);